import React from 'react'
import { InputsContainer } from '../../ui/form'
import { Button } from '../../ui/button'
import useIsMobile from '../../../hooks/useIsMobile'
import Autocomplete from '../../ui/autoComplete'
import ClinicSelect from '../../clinicSelect'

const AppointmentSearchFilters = ({
	values,
	errors,
	touched,
	handleSubmit,
	setFieldValue,
	specialties,
	clinics,
	professionalOptions,
	onChangeSpeciality,
	onChangeClinic,
	getClinicOptions
}) => {
	const isMobile = useIsMobile()
	const hasSelectedClinic = Array.isArray(values.clinic)
		? values.clinic.length > 0
		: !!values.clinic

	return (
		<InputsContainer maxWidth="360px" gap={24} mb={16} heightMobile="100%">
			<Autocomplete
				label={'Especialidad'}
				name="speciality"
				value={values.speciality}
				onChange={e => onChangeSpeciality(e.target?.value ?? e, setFieldValue)}
				options={specialties}
				error={touched.speciality && errors.speciality}
				placeholder="Selecciona una especialidad"
			/>
			<ClinicSelect
				label={'Clínica / Centro médico'}
				name="clinic"
				value={values.clinic}
				onChange={selected => onChangeClinic(selected, setFieldValue, values.speciality)}
				options={clinics}
				error={touched.clinic && errors.clinic}
				isClearable
				disabled={!values.speciality}
				placeholder={
					!values.speciality ? 'Primero selecciona especialidad' : 'Selecciona una clínica'
				}
				isMultiSelect
			/>
			<Autocomplete
				label={'Profesional (Opcional)'}
				name="professional"
				value={values.professional}
				onChange={e => setFieldValue('professional', e.target?.value || null)}
				onOpenRequest={() => getClinicOptions(values.clinicCode, values.speciality)}
				openOnFocus
				options={professionalOptions}
				error={touched.professional && errors.professional}
				isClearable
				disabled={!values.speciality || !hasSelectedClinic}
				placeholder={
					!values.speciality || !hasSelectedClinic
						? 'Primero selecciona especialidad y clínica'
						: 'Selecciona un profesional'
				}
			/>
			<Button
				onClick={handleSubmit}
				type="submit"
				label={'Continuar'}
				size={isMobile ? 'mobile' : 'xlarge'}
				disabled={!values.speciality || !hasSelectedClinic}
			/>
		</InputsContainer>
	)
}

export default AppointmentSearchFilters
